export default __webpack_public_path__ + "static/media/imgfile.abf8843f.svg";